import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { UserInfo } from "../../../shared/types/user-info";
import { CompanyAttachment } from "./company-attachment.type";

//#region Search Filter Options

export const getContractAttachmentSearchFilterOptions = (
  _user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
  },
): SearchFilterOption<CompanyAttachment>[] => {
  const { shown, hidden } = config || {};

  return (
    [
      { value: "extension", label: "File Type" },
      { value: "name", label: "Name" },
      { value: "description", label: "Description" },
    ] as SearchFilterOption<CompanyAttachment>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};

//#endregion
